import _defineProperty from "/Users/matt/dev/github.com/industriousapps/excelkits-client/node_modules/.pnpm/next@13.5.7_@babel+core@7.25.2_react-dom@18.3.1_react@18.3.1__react@18.3.1_sass@1.79.3/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import React from "react";
import Link from 'next/link';
import generalConfig from '@/config/general';
import Button from '@/components/Button';
import { FREE_SEAT } from '@/config/monetization';
import { formatNumber } from '@/common/utils/strings';
import ButtonList from '@/components/ButtonList';
import Tooltip from '@/components/Tooltip';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";

var GoogleSheetsLogo = function GoogleSheetsLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M271.25 0H40.6875C18.3094 0 0 16.3841 0 36.4091V497.591C0 517.616 18.3094 534 40.6875 534H393.312C415.69 534 434 517.616 434 497.591V145.636L339.062 84.9545L271.25 0Z",
      fill: "#0F9D58"
    }), /*#__PURE__*/_jsx("path", {
      d: "M108.5 260.932V436.909H325.5V260.932H108.5ZM203.438 412.637H135.625V382.296H203.438V412.637ZM203.438 364.091H135.625V333.75H203.438V364.091ZM203.438 315.546H135.625V285.205H203.438V315.546ZM298.375 412.637H230.563V382.296H298.375V412.637ZM298.375 364.091H230.563V333.75H298.375V364.091ZM298.375 315.546H230.563V285.205H298.375V315.546Z",
      fill: "#F1F1F1"
    }), /*#__PURE__*/_jsx("path", {
      d: "M271.249 0V109.227C271.249 129.343 289.457 145.636 311.936 145.636H433.999L271.249 0Z",
      fill: "#87CEAC"
    }), /*#__PURE__*/_jsx("path", {
      d: "M40.6875 0C18.3094 0 0 16.3841 0 36.4091V39.4432C0 19.4182 18.3094 3.03409 40.6875 3.03409H271.25V0H40.6875Z",
      fill: "white",
      fillOpacity: "0.2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M393.312 530.965H40.6875C18.3094 530.965 0 514.581 0 494.556V497.59C0 517.615 18.3094 534 40.6875 534H393.312C415.69 534 434 517.615 434 497.59V494.556C434 514.581 415.69 530.965 393.312 530.965Z",
      fill: "#263238",
      fillOpacity: "0.2"
    }), /*#__PURE__*/_jsx("path", {
      d: "M311.936 145.636C289.457 145.636 271.249 129.343 271.249 109.227V112.261C271.249 132.377 289.457 148.67 311.936 148.67H433.999V145.636H311.936Z",
      fill: "#263238",
      fillOpacity: "0.1"
    })]
  }));
};

GoogleSheetsLogo.defaultProps = {
  width: "434",
  height: "534",
  viewBox: "0 0 434 534",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var AppleNumbersLogo = function AppleNumbersLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_3_2)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M122.539 0H411.462C479.348 0 534 54.6529 534 122.539V411.461C534 479.348 479.348 534 411.462 534H122.539C54.6529 534 0 479.348 0 411.461V122.539C0 54.6529 54.6529 0 122.539 0V0Z",
        fill: "url(#paint0_linear_3_2)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M177.365 263.186H255.558C256.443 263.186 257.292 263.538 257.918 264.164C258.544 264.789 258.895 265.638 258.895 266.524V400.977C258.895 401.862 258.544 402.711 257.918 403.337C257.292 403.963 256.443 404.314 255.558 404.314H177.365C176.48 404.314 175.631 403.963 175.005 403.337C174.379 402.711 174.027 401.862 174.027 400.977V266.524C174.027 265.638 174.379 264.789 175.005 264.164C175.631 263.538 176.48 263.186 177.365 263.186V263.186Z",
        fill: "url(#paint1_linear_3_2)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M78.1981 343.286H158.077C159.454 343.286 160.572 344.309 160.572 345.572V402.029C160.572 403.291 159.454 404.314 158.077 404.314H78.1981C76.821 404.314 75.7036 403.291 75.7036 402.029V345.572C75.7036 344.31 76.821 343.286 78.1981 343.286Z",
        fill: "url(#paint2_linear_3_2)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M276.155 103.045H354.348C356.191 103.045 357.685 104.537 357.685 106.378V400.983C357.685 401.421 357.598 401.854 357.43 402.259C357.263 402.663 357.017 403.03 356.707 403.34C356.397 403.649 356.029 403.894 355.624 404.062C355.219 404.229 354.786 404.315 354.348 404.314H276.155C274.311 404.314 272.817 402.823 272.817 400.983V106.378C272.818 105.94 272.904 105.506 273.072 105.102C273.24 104.697 273.486 104.33 273.796 104.02C274.106 103.711 274.474 103.465 274.878 103.298C275.283 103.131 275.717 103.045 276.155 103.045V103.045Z",
        fill: "url(#paint3_linear_3_2)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M374.608 191.207H453.475C455.132 191.207 456.475 192.603 456.475 194.325V401.196C456.475 402.918 455.132 404.314 453.475 404.314H374.608C372.951 404.314 371.607 402.918 371.607 401.196V194.325C371.607 192.603 372.95 191.207 374.608 191.207Z",
        fill: "url(#paint4_linear_3_2)"
      }), /*#__PURE__*/_jsx("path", {
        d: "M80.4917 419.809H452.146C456.36 419.809 459.775 422.587 459.775 426.014V427.921C459.775 431.348 456.36 434.125 452.146 434.125H80.4917C76.2784 434.125 72.8628 431.348 72.8628 427.921V426.014C72.8628 422.587 76.2784 419.809 80.4917 419.809Z",
        fill: "url(#paint5_linear_3_2)"
      })]
    }), /*#__PURE__*/_jsxs("defs", {
      children: [/*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_3_2",
        x1: "266.755",
        y1: "531.887",
        x2: "267.275",
        y2: "6.48899",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#11D51D"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#82FA6C"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint1_linear_3_2",
        x1: "220.473",
        y1: "104.365",
        x2: "214.752",
        y2: "431.44",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint2_linear_3_2",
        x1: "122.881",
        y1: "102.655",
        x2: "117.159",
        y2: "429.733",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint3_linear_3_2",
        x1: "317.834",
        y1: "106.068",
        x2: "312.112",
        y2: "433.142",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint4_linear_3_2",
        x1: "417.365",
        y1: "107.809",
        x2: "411.643",
        y2: "434.884",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint5_linear_3_2",
        x1: "271.947",
        y1: "105.265",
        x2: "266.225",
        y2: "432.34",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "white"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "white"
        })]
      }), /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_3_2",
        children: /*#__PURE__*/_jsx("rect", {
          width: "534",
          height: "534",
          fill: "white"
        })
      })]
    })]
  }));
};

AppleNumbersLogo.defaultProps = {
  width: "534",
  height: "534",
  viewBox: "0 0 534 534",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}; // import AirTableLogo from '../../../../../public/icons/logos/airtable.svg';

var MicrosoftExcelLogo = function MicrosoftExcelLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsx("path", {
      d: "M360.333 253.667L133.667 213.667V509.227C133.667 522.725 144.609 533.667 158.107 533.667H549.227C562.725 533.667 573.667 522.725 573.667 509.227V400.333L360.333 253.667Z",
      fill: "#185C37"
    }), /*#__PURE__*/_jsx("path", {
      d: "M360.333 0.333252H158.107C144.609 0.333252 133.667 11.2753 133.667 24.7732V133.667L360.333 267L480.333 307L573.667 267V133.667L360.333 0.333252Z",
      fill: "#21A366"
    }), /*#__PURE__*/_jsx("path", {
      d: "M133.667 133.667H360.333V267H133.667V133.667Z",
      fill: "#107C41"
    }), /*#__PURE__*/_jsx("path", {
      opacity: "0.1",
      d: "M295.893 107H133.667V440.333H295.893C309.373 440.29 320.29 429.373 320.333 415.893V131.44C320.29 117.96 309.373 107.044 295.893 107Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      opacity: "0.2",
      d: "M282.56 120.333H133.667V453.667H282.56C296.04 453.623 306.956 442.706 307 429.227V144.773C306.956 131.294 296.04 120.377 282.56 120.333Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      opacity: "0.2",
      d: "M282.56 120.333H133.667V427H282.56C296.04 426.956 306.956 416.04 307 402.56V144.773C306.956 131.294 296.04 120.377 282.56 120.333Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      opacity: "0.2",
      d: "M269.227 120.333H133.667V427H269.227C282.706 426.956 293.623 416.04 293.667 402.56V144.773C293.623 131.294 282.706 120.377 269.227 120.333Z",
      fill: "black"
    }), /*#__PURE__*/_jsx("path", {
      d: "M24.7732 120.333H269.226C282.724 120.333 293.666 131.275 293.666 144.773V389.226C293.666 402.724 282.724 413.666 269.226 413.666H24.7732C11.2753 413.667 0.333252 402.724 0.333252 389.227V144.773C0.333252 131.275 11.2753 120.333 24.7732 120.333Z",
      fill: "url(#paint0_linear_1_40)"
    }), /*#__PURE__*/_jsx("path", {
      d: "M76.0266 346.44L127.44 266.773L80.3333 187.547H118.227L143.933 238.213C146.307 243.027 147.933 246.6 148.813 248.96H149.147C150.808 245.177 152.587 241.446 154.48 237.773L181.96 187.573H216.746L168.44 266.333L217.973 346.44H180.96L151.267 290.827C149.868 288.461 148.681 285.975 147.72 283.4H147.28C146.41 285.923 145.256 288.338 143.84 290.6L113.267 346.44H76.0266Z",
      fill: "white"
    }), /*#__PURE__*/_jsx("path", {
      d: "M549.227 0.333252H360.333V133.667H573.667V24.7732C573.667 11.2753 562.725 0.333252 549.227 0.333252Z",
      fill: "#33C481"
    }), /*#__PURE__*/_jsx("path", {
      d: "M360.333 267H573.667V400.333H360.333V267Z",
      fill: "#107C41"
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsxs("linearGradient", {
        id: "paint0_linear_1_40",
        x1: "51.2911",
        y1: "101.236",
        x2: "242.709",
        y2: "432.763",
        gradientUnits: "userSpaceOnUse",
        children: [/*#__PURE__*/_jsx("stop", {
          stopColor: "#18884F"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "0.5",
          stopColor: "#117E43"
        }), /*#__PURE__*/_jsx("stop", {
          offset: "1",
          stopColor: "#0B6631"
        })]
      })
    })]
  }));
};

MicrosoftExcelLogo.defaultProps = {
  width: "574",
  height: "534",
  viewBox: "0 0 574 534",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ShopifyLogo = function ShopifyLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_1_69)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M409.05 104.861C408.683 102.191 406.345 100.714 404.413 100.551C402.485 100.39 361.672 97.3635 361.672 97.3635C361.672 97.3635 333.328 69.2096 330.217 66.0934C327.104 62.979 321.024 63.9263 318.664 64.6213C318.317 64.7237 312.472 66.5287 302.802 69.5224C293.334 42.2628 276.624 17.2123 247.226 17.2123C246.415 17.2123 245.579 17.2452 244.744 17.2928C236.384 6.23056 226.027 1.42456 217.081 1.42456C148.601 1.42456 115.884 87.0749 105.626 130.6C79.016 138.849 60.1123 144.714 57.6977 145.473C42.8445 150.134 42.3748 150.603 40.4244 164.605C38.9567 175.207 0.0927734 475.909 0.0927734 475.909L302.928 532.678L467.015 497.163C467.015 497.163 409.414 107.531 409.052 104.861H409.05ZM286.065 74.7014L260.44 82.6364C260.449 80.8296 260.458 79.0521 260.458 77.1081C260.458 60.1664 258.108 46.5256 254.337 35.7121C269.484 37.614 279.572 54.8575 286.065 74.7014ZM235.546 39.0716C239.758 49.629 242.496 64.7804 242.496 85.226C242.496 86.272 242.487 87.2285 242.478 88.1959C225.813 93.3603 207.704 98.9673 189.556 104.593C199.746 65.2449 218.847 46.2403 235.546 39.0716V39.0716ZM215.2 19.8018C218.156 19.8018 221.134 20.8058 223.983 22.7681C202.036 33.1006 178.512 59.124 168.577 111.092L126.745 124.054C138.381 84.4158 166.011 19.8018 215.199 19.8018H215.2Z",
        fill: "#95BF46"
      }), /*#__PURE__*/_jsx("path", {
        d: "M404.413 100.551C402.485 100.39 361.672 97.3636 361.672 97.3636C361.672 97.3636 333.328 69.2098 330.217 66.0936C329.052 64.9341 327.482 64.3398 325.841 64.0837L302.943 532.674L467.015 497.163C467.015 497.163 409.412 107.532 409.05 104.862C408.683 102.192 406.345 100.714 404.413 100.551",
        fill: "#5E8E3E"
      }), /*#__PURE__*/_jsx("path", {
        d: "M247.227 191.262L226.994 251.476C226.994 251.476 209.267 242.01 187.538 242.01C155.682 242.01 154.079 262.011 154.079 267.051C154.079 294.552 225.731 305.09 225.731 369.506C225.731 420.187 193.603 452.821 150.282 452.821C98.2982 452.821 71.7139 420.452 71.7139 420.452L85.633 374.44C85.633 374.44 112.959 397.912 136.018 397.912C151.085 397.912 157.214 386.044 157.214 377.372C157.214 341.498 98.4298 339.898 98.4298 280.952C98.4298 231.339 134.022 183.328 205.868 183.328C233.55 183.328 247.227 191.262 247.227 191.262",
        fill: "white"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_1_69",
        children: /*#__PURE__*/_jsx("rect", {
          width: "467.978",
          height: "534",
          fill: "white"
        })
      })
    })]
  }));
};

ShopifyLogo.defaultProps = {
  width: "468",
  height: "534",
  viewBox: "0 0 468 534",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var WixLogo = function WixLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_3547_22992)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M13 26C20.1797 26 26 20.1797 26 13C26 5.8203 20.1797 0 13 0C5.8203 0 0 5.8203 0 13C0 20.1797 5.8203 26 13 26Z",
        fill: "#F5F5F7"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.9369 10.5675C14.135 10.4634 14.4904 10.4736 14.4904 10.4736C14.4904 10.8189 14.4574 11.0246 14.2391 11.1845C14.1705 11.2353 14.0486 11.314 13.909 11.3648C13.716 11.4359 13.584 11.5603 13.584 11.5603C13.584 10.9306 13.6805 10.7021 13.9369 10.5675ZM12.4109 10.7148C12.2002 10.9001 12.1393 11.1947 12.1393 11.1947L11.4436 13.8886L10.8646 11.6822C10.8088 11.4486 10.7072 11.1566 10.5473 10.9611C10.3416 10.7123 9.9252 10.6945 9.88203 10.6945C9.83887 10.6945 9.42246 10.7097 9.2168 10.9611C9.05684 11.1566 8.95527 11.446 8.89941 11.6822L8.31797 13.8886L7.62227 11.1947C7.62227 11.1947 7.56133 10.9001 7.35059 10.7148C7.01035 10.4152 6.5 10.4787 6.5 10.4787L7.83047 15.5136C7.83047 15.5136 8.26973 15.5441 8.49062 15.4324C8.78008 15.2851 8.91719 15.1709 9.09238 14.4853C9.24727 13.8734 9.68398 12.0808 9.72461 11.9513C9.74492 11.8878 9.77031 11.738 9.88203 11.738C9.99629 11.738 10.0191 11.8878 10.0395 11.9513C10.0801 12.0783 10.5168 13.8734 10.6717 14.4853C10.8469 15.1709 10.984 15.2851 11.2734 15.4324C11.4943 15.5441 11.9336 15.5136 11.9336 15.5136L13.2666 10.4761C13.2615 10.4787 12.7512 10.4126 12.4109 10.7148ZM14.4904 11.3013C14.4904 11.3013 14.4066 11.4308 14.2162 11.5375C14.0943 11.606 13.9775 11.6517 13.8506 11.7126C13.6398 11.8142 13.584 11.9259 13.584 12.0986V15.5136C13.584 15.5136 13.9191 15.5568 14.14 15.4451C14.4219 15.3003 14.4879 15.1607 14.4904 14.5361V11.3013ZM17.8115 13.0076L19.5025 10.4939C19.5025 10.4939 18.7891 10.372 18.4361 10.6945C18.2102 10.9002 17.9563 11.2709 17.9563 11.2709L17.3342 12.1671C17.3037 12.2128 17.2656 12.2636 17.2021 12.2636C17.1387 12.2636 17.1006 12.2128 17.0701 12.1671L16.448 11.2709C16.448 11.2709 16.1941 10.9002 15.9682 10.6945C15.6152 10.372 14.9018 10.4939 14.9018 10.4939L16.5928 13.0076L14.9043 15.5136C14.9043 15.5136 15.6482 15.6076 16.0012 15.2851C16.2271 15.0794 16.4455 14.7443 16.4455 14.7443L17.0676 13.848C17.098 13.8023 17.1361 13.7515 17.1996 13.7515C17.2631 13.7515 17.3012 13.8023 17.3316 13.848L17.9537 14.7443C17.9537 14.7443 18.1848 15.0794 18.4107 15.2851C18.7637 15.6076 19.4949 15.5136 19.4949 15.5136L17.8115 13.0076Z",
        fill: "#121319"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_3547_22992",
        children: /*#__PURE__*/_jsx("rect", {
          width: "26",
          height: "26",
          fill: "white"
        })
      })
    })]
  }));
};

WixLogo.defaultProps = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}; // import NotionLogo from '../../../../../public/icons/logos/notion.svg';

var WordpressLogo = function WordpressLogo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_3547_22995)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M1.84784 12.9992C1.84784 17.4133 4.41311 21.2281 8.13294 23.0358L2.81334 8.46074C2.17565 9.88874 1.84664 11.4353 1.84784 12.9992ZM20.5281 12.4365C20.5281 11.0582 20.033 10.1038 19.6084 9.36086C19.0431 8.44226 18.5132 7.66434 18.5132 6.74573C18.5132 5.72059 19.2907 4.76634 20.3859 4.76634C20.4353 4.76634 20.4822 4.7725 20.5304 4.77526C18.5463 2.95758 15.903 1.84778 12.9997 1.84778C9.10377 1.84778 5.67612 3.84668 3.68208 6.87433C3.94372 6.88217 4.1903 6.88769 4.39974 6.88769C5.56618 6.88769 7.37178 6.74614 7.37178 6.74614C7.97295 6.71072 8.04384 7.59368 7.4433 7.66475C7.4433 7.66475 6.83919 7.73586 6.16695 7.77106L10.228 19.8505L12.6684 12.5311L10.931 7.77065C10.3305 7.73541 9.76156 7.66434 9.76156 7.66434C9.16062 7.6291 9.23105 6.71031 9.832 6.74573C9.832 6.74573 11.6737 6.88728 12.7695 6.88728C13.9357 6.88728 15.7415 6.74573 15.7415 6.74573C16.3431 6.71031 16.4138 7.59327 15.813 7.66434C15.813 7.66434 15.2076 7.73541 14.5366 7.77065L18.5667 19.7586L19.6791 16.0415C20.1612 14.499 20.5281 13.3911 20.5281 12.4365Z",
        fill: "#F5F5F7"
      }), /*#__PURE__*/_jsx("path", {
        d: "M13.1953 13.9748L9.84937 23.6974C10.8723 23.9988 11.9333 24.1518 12.9997 24.1518C14.2983 24.1518 15.5437 23.9273 16.7029 23.5197C16.672 23.4709 16.6455 23.4195 16.6236 23.366L13.1953 13.9748ZM22.785 7.64893C22.8329 8.00414 22.8601 8.38549 22.8601 8.79564C22.8601 9.92728 22.6487 11.1994 22.0122 12.79L18.6057 22.6388C21.9211 20.7055 24.1511 17.1136 24.1511 12.9995C24.1513 11.0606 23.656 9.23746 22.785 7.64893Z",
        fill: "#F5F5F7"
      }), /*#__PURE__*/_jsx("path", {
        d: "M12.9997 0C5.83184 0 0 5.83143 0 12.9993C0 20.1679 5.83184 25.9991 12.9997 25.9991C20.1673 25.9991 26 20.1679 26 12.9993C25.9998 5.83143 20.1673 0 12.9997 0ZM12.9997 25.4033C6.16055 25.4033 0.596066 19.8388 0.596066 12.9993C0.596066 6.1601 6.16032 0.596066 12.9997 0.596066C19.8386 0.596066 25.4027 6.1601 25.4027 12.9993C25.4027 19.8388 19.8386 25.4033 12.9997 25.4033Z",
        fill: "#F5F5F7"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_3547_22995",
        children: /*#__PURE__*/_jsx("rect", {
          width: "26",
          height: "26",
          fill: "white"
        })
      })
    })]
  }));
};

WordpressLogo.defaultProps = {
  width: "26",
  height: "26",
  viewBox: "0 0 26 26",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Html5Logo = function Html5Logo(props) {
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({}, props), {}, {
    children: [/*#__PURE__*/_jsxs("g", {
      clipPath: "url(#clip0_3457_22840)",
      children: [/*#__PURE__*/_jsx("path", {
        d: "M33.644 370.877L0.633003 0.619995H363.367L330.321 370.819L181.778 412L33.644 370.877Z",
        fill: "#E44D26"
      }), /*#__PURE__*/_jsx("path", {
        d: "M182 380.523L302.03 347.246L330.27 30.894H182V380.523Z",
        fill: "#F16529"
      }), /*#__PURE__*/_jsx("path", {
        d: "M182 168.217H121.91L117.76 121.716H182V76.305H181.843H68.132L69.219 88.488L80.38 213.627H182V168.217Z",
        fill: "#EBEBEB"
      }), /*#__PURE__*/_jsx("path", {
        d: "M182 286.153L181.801 286.206L131.227 272.55L127.994 236.333H103.419H82.409L88.771 307.634L181.791 333.457L182 333.399V286.153Z",
        fill: "#EBEBEB"
      }), /*#__PURE__*/_jsx("path", {
        d: "M181.843 168.217V213.627H237.761L232.49 272.521L181.843 286.191V333.435L274.937 307.634L275.62 299.962L286.291 180.411L287.399 168.217H275.162H181.843Z",
        fill: "white"
      }), /*#__PURE__*/_jsx("path", {
        d: "M181.843 76.305V104.509V121.605V121.716H291.385H291.531L292.442 111.509L294.511 88.488L295.597 76.305H181.843Z",
        fill: "white"
      })]
    }), /*#__PURE__*/_jsx("defs", {
      children: /*#__PURE__*/_jsx("clipPath", {
        id: "clip0_3457_22840",
        children: /*#__PURE__*/_jsx("rect", {
          width: "364",
          height: "412",
          fill: "white"
        })
      })
    })]
  }));
};

Html5Logo.defaultProps = {
  width: "364",
  height: "412",
  viewBox: "0 0 364 412",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

const FeaturedPurchase = _ref => {
  let {
    onVideoClick
  } = _ref;
  return /*#__PURE__*/_jsx("section", {
    className: styles.container,
    children: /*#__PURE__*/_jsxs("div", {
      className: styles.main,
      children: [/*#__PURE__*/_jsxs("div", {
        className: styles.main__content,
        children: [/*#__PURE__*/_jsxs("header", {
          className: styles.header,
          children: [/*#__PURE__*/_jsx("h1", {
            className: styles.heading,
            children: "Create Immersive No-Code Charts & Dashboards Using Your Data"
          }), /*#__PURE__*/_jsx("p", {
            className: styles.subHeading,
            children: "Universally embeddable widgets that drive traffic and increase conversions."
          })]
        }), /*#__PURE__*/_jsx(ButtonList, {
          className: styles.buttonList,
          variant: "grid",
          children: /*#__PURE__*/_jsx(Link, {
            legacyBehavior: true,
            href: `/signup`,
            children: /*#__PURE__*/_jsx("a", {
              className: styles.buttonItemLink,
              children: /*#__PURE__*/_jsx(Button, {
                size: "large",
                type: "button",
                children: "Get started - it\u2019s free"
              })
            })
          })
        }), /*#__PURE__*/_jsxs("span", {
          className: styles.smallText,
          children: ["Sign up for ", FREE_SEAT.chartLimit, " charts and", ' ', formatNumber(FREE_SEAT.viewLimit), "/mo views."]
        })]
      }), /*#__PURE__*/_jsxs("aside", {
        className: styles.main__aside,
        children: [/*#__PURE__*/_jsx("img", {
          src: "/img/pages/home/dashboard-builder.webp",
          loading: "lazy",
          alt: "Customizing a dashboard from an Excel spreadsheet"
        }), onVideoClick && /*#__PURE__*/_jsx("img", {
          className: styles.video,
          src: "/img/pages/home/video-poster.webp",
          alt: `Teaser for demo using ${generalConfig.productName} and publishing on any platform`,
          style: {
            aspectRatio: '1452 / 968'
          },
          onClick: onVideoClick
        })]
      }), /*#__PURE__*/_jsx("footer", {
        className: styles.main__footer,
        children: /*#__PURE__*/_jsxs("ul", {
          className: styles.buckets,
          children: [/*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("h6", {
              className: styles.minorHeading,
              children: "Supports"
            }), /*#__PURE__*/_jsxs("ul", {
              className: styles.bucketIconList,
              children: [/*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Tooltip, {
                  placement: "right",
                  content: "Microsoft Excel",
                  children: /*#__PURE__*/_jsx(MicrosoftExcelLogo, {
                    className: styles.bucketIcon
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Tooltip, {
                  placement: "right",
                  content: "Google Sheets",
                  children: /*#__PURE__*/_jsx(GoogleSheetsLogo, {
                    className: styles.bucketIcon
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Tooltip, {
                  placement: "bottom",
                  content: "Apple Numbers",
                  children: /*#__PURE__*/_jsx(AppleNumbersLogo, {
                    className: styles.bucketIcon
                  })
                })
              })]
            })]
          }), /*#__PURE__*/_jsxs("li", {
            children: [/*#__PURE__*/_jsx("h6", {
              className: styles.minorHeading,
              children: "Platforms"
            }), /*#__PURE__*/_jsxs("ul", {
              className: styles.bucketIconList,
              children: [/*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Tooltip, {
                  placement: "bottom",
                  content: "Wordpress",
                  children: /*#__PURE__*/_jsx(WordpressLogo, {
                    className: styles.bucketIcon
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Tooltip, {
                  placement: "bottom",
                  content: "Shopify",
                  children: /*#__PURE__*/_jsx(ShopifyLogo, {
                    className: styles.bucketIcon
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Tooltip, {
                  placement: "bottom",
                  content: "Wix",
                  children: /*#__PURE__*/_jsx(WixLogo, {
                    className: styles.bucketIcon
                  })
                })
              }), /*#__PURE__*/_jsx("li", {
                children: /*#__PURE__*/_jsx(Tooltip, {
                  placement: "bottom",
                  content: "HTML5 + Custom Sites",
                  children: /*#__PURE__*/_jsx(Html5Logo, {
                    className: styles.bucketIcon
                  })
                })
              })]
            })]
          })]
        })
      })]
    })
  });
};

export default FeaturedPurchase; // Responsive images:
// const FEATURED_SRCSET: string = [
//   '/img/pages/home/small-splash.webp 320w',
//   '/img/pages/home/small-splash@2x.webp 640w',
//   '/img/pages/home/large-splash.webp 990w',
//   '/img/pages/home/large-splash@2x.webp 1980w',
// ].join(', ');
// const FEATURED_SIZES: string = [
//   '(max-width: 639px) 320w',
//   '(min-width: 640px) 640w',
//   '(min-width: 990px) 990w',
//   '(min-width: 1980px) 1980w',
// ].join(', ');
// {/* Add to main aside image to support responsive images srcSet={FEATURED_SRCSET} sizes={FEATURED_SIZES} */}